import React from 'react';
import { array } from 'prop-types';
import FaqTreeItem from './FaqTreeItem';

const propTypes = {
  pages: array.isRequired,
};

const defaultProps = {
  pages: [],
};

const FaqTreeList = ({ pages, className, currentItem, closeModal }) => (
  <ul className={className}>
    {pages.map((item) => (
      <FaqTreeItem key={item.id} article={item} currentItem={currentItem} closeModal={closeModal} />
    ))}
  </ul>
);

FaqTreeList.propTypes = propTypes;
FaqTreeList.defaultProps = defaultProps;

export default FaqTreeList;
